import React from 'react';
import { message } from 'antd';
import fail from '../../static/msg-fail.svg';
import success from '../../static/msg-success.svg';
import classNames from 'classnames';

export default {
  error({ duration = 2.8, content, className }) {
    if (!content) {
      return;
    }
    message.config({
      duration,
    });
    message.destroy();
    this.destroy();
    message.error(
      {
        content,
        icon: <img className={classNames('ant-message-custom-img', className)} src={fail} alt="" />,
      },
      duration,
    );
  },
  success({ duration = 2.8, content, className, onClose }) {
    if (!content) {
      return;
    }
    message.config({
      duration,
    });
    message.destroy();
    this.destroy();
    message.success(
      {
        content,
        icon: (
          <img className={classNames('ant-message-custom-img', className)} src={success} alt="" />
        ),
        onClose: onClose,
      },
      duration,
    );
  },
  destroy() {
    try {
      const el = document.body || document.documentElement;
      const messageInstance = el.querySelectorAll('.ant-message');
      // eslint-disable-next-line no-return-assign
      messageInstance.forEach(instance => (instance.style.cssText = 'display:none;'));
    } catch (err) {}
  },
};
